import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import { getGlobalParams } from 'config/config'

import './style.scss'

// Reference: https://reactrouter.com/web/api/Link
const Link = ({ value, to, replace, followingDisclaimer, disclaimerClasses, target, linkState, extraClasses, onClick }) => {
  const [baseUrl, setBaseUrl] = useState('')

  useEffect(() => {
    const { baseUrl: globalBaseUrl } = getGlobalParams()
    setBaseUrl(globalBaseUrl)
  }, [])

  return (
    <div className={extraClasses}>
      <RouterLink
        target={target}
        onClick={onClick}
        to={{
          pathname: `${baseUrl}${to}`,
          state: linkState
        }}
        replace={replace}
      >
        {value}
      </RouterLink>
      {followingDisclaimer && (
        <span className={disclaimerClasses}>
          <FormattedMessage id={followingDisclaimer} defaultMessage={followingDisclaimer} />
        </span>
      )}
    </div>
  )
}

Link.propTypes = {
  value: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  linkState: PropTypes.object,
  replace: PropTypes.bool,
  followingDisclaimer: PropTypes.string,
  disclaimerClasses: PropTypes.string,
  target: PropTypes.string,
  extraClasses: PropTypes.string,
  onClick: PropTypes.func
}

Link.defaultProps = {
  replace: false,
  followingDisclaimer: '',
  disclaimerClasses: '',
  target: '_self',
  linkState: {},
  extraClasses: '',
  onClick: () => {}
}

export default Link
